var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5340_4717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38317 0 0 5.38317 0 12C0 18.6168 5.38317 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38317 18.6168 0 12 0ZM12 22.5C6.21028 22.5 1.5 17.7897 1.5 12C1.5 6.21028 6.21028 1.5 12 1.5C17.7897 1.5 22.5 6.21028 22.5 12C22.5 17.7897 17.7897 22.5 12 22.5ZM14.7959 10.3035C14.595 10.2258 14.3703 10.2383 14.1792 10.3379C12.6721 11.1227 11.3279 11.1227 9.82078 10.3379C9.62972 10.2383 9.40505 10.2257 9.20409 10.3035C8.08594 10.7354 7.14816 11.4341 6.49219 12.3241C5.80467 13.2569 5.4413 14.3829 5.4413 15.5803V17.0995C5.4413 18.1264 6.2767 18.9618 7.30359 18.9618H16.6964C17.7232 18.9618 18.5587 18.1264 18.5587 17.0995V15.5803C18.5587 14.3829 18.1953 13.257 17.5078 12.3241C16.8519 11.4342 15.9141 10.7354 14.7959 10.3035ZM17.0587 17.0995C17.0587 17.2993 16.8962 17.4618 16.6964 17.4618H7.30359C7.10381 17.4618 6.9413 17.2993 6.9413 17.0995V15.5803C6.9413 13.9306 7.87252 12.5479 9.44977 11.8268C11.1626 12.622 12.8377 12.6219 14.5503 11.8268C16.1275 12.548 17.0588 13.9306 17.0588 15.5803V17.0995H17.0587ZM12 9.73842C13.7477 9.73842 15.1695 8.31661 15.1695 6.56892C15.1695 4.82123 13.7477 3.39937 12 3.39937C10.2523 3.39937 8.8305 4.82123 8.8305 6.56892C8.8305 8.31661 10.2523 9.73842 12 9.73842ZM12 4.89937C12.9206 4.89937 13.6695 5.64834 13.6695 6.56892C13.6695 7.4895 12.9205 8.23842 12 8.23842C11.0795 8.23842 10.3305 7.48945 10.3305 6.56892C10.3305 5.6483 11.0794 4.89937 12 4.89937Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5340_4717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.6f17875e66f61f1f8aca25cd892eecc0.svg";
export { ForwardRef as ReactComponent };